var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0025 1H3.00031C1.89557 1 1 1.89557 1 3.00031V4.17207C1 4.70259 1.21074 5.21137 1.58588 5.58651L7.41521 11.4158C7.79035 11.791 8.00109 12.2998 8.00109 12.8302V18.0027V18.2884C8.00109 18.9211 8.76611 19.2379 9.21348 18.7906L10.0014 18.0027L11.4158 16.5882C11.791 16.2131 12.0017 15.7043 12.0017 15.1738V12.8302C12.0017 12.2998 12.2125 11.791 12.5876 11.4158L18.4169 5.58651C18.7921 5.21137 19.0028 4.70259 19.0028 4.17207V3.00031C19.0028 1.89557 18.1073 1 17.0025 1Z",
    stroke: "#0078E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.b1096fbfe468e03c74438d817d49b560.svg";
export { ForwardRef as ReactComponent };